import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";
import MenuModal from "./MenuModal";
import "./MenuList.css";

const MenuList = () => {
  const [menus, setMenus] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingMenu, setEditingMenu] = useState(null);

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    try {
      const res = await axiosClient.get(API_ENDPOINTS.menus);
      // Sắp xếp menu theo ParentId trước, sau đó theo Order
      const sortedMenus = (res.data || []).sort((a, b) => 
        (a.parentId || 0) - (b.parentId || 0) || a.order - b.order
      );
      setMenus(sortedMenus);
    } catch (error) {
      console.error("Error loading menus:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this menu item? This action cannot be undone.")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.menus}/${id}`);
      fetchMenus();
    } catch (error) {
      alert("Failed to delete menu item.");
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="m-0 font-weight-bold text-dark text-uppercase">Menu Configuration</h5>
            <small className="text-muted">Manage system navigation structure and access paths</small>
          </div>
          <button 
            className="btn btn-primary btn-sm px-3 rounded-pill"
            onClick={() => { setEditingMenu(null); setShowModal(true); }}
          >
            <i className="fas fa-plus me-2"></i> Add New Menu
          </button>
        </div>

        <div className="card-body p-0">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="ps-4">Title</th>
                <th>URL Path</th>
                <th>Icon</th>
                <th>Parent ID</th>
                <th>Display Order</th>
                <th className="text-center">Status</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {menus.length > 0 ? menus.map((m) => (
                <tr key={m.id} className={!m.parentId ? "table-active" : ""}>
                  <td className={`ps-4 fw-bold ${!m.parentId ? "text-primary" : ""}`}>
                    {m.parentId ? `↳ ${m.title}` : m.title}
                  </td>
                  <td><code className="text-muted">{m.url || "---"}</code></td>
                  <td><i className={`fas ${m.icon}`}></i> <small className="text-muted">{m.icon}</small></td>
                  <td>{m.parentId || <span className="text-muted small">Root</span>}</td>
                  <td>{m.order}</td>
                  <td className="text-center">
                    <span className={`badge ${m.isActive ? "bg-success" : "bg-secondary"}`}>
                      {m.isActive ? "Active" : "Disabled"}
                    </span>
                  </td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary border-0 me-2" onClick={() => { setEditingMenu(m); setShowModal(true); }}>
                      <i className="fas fa-edit"></i>
                    </button>
                    <button className="btn btn-sm btn-outline-danger border-0" onClick={() => handleDelete(m.id)}>
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-muted">No menu items found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <MenuModal
          show={showModal}
          initialData={editingMenu}
          onClose={() => setShowModal(false)}
          onSave={() => { setShowModal(false); fetchMenus(); }}
        />
      )}
    </div>
  );
};

export default MenuList;